<div class="container">
  <h1 class="main-title">Frequently Asked Questions</h1>
  <p class="sub-title">These are some of the questions we get asked the most.</p>

  <p-accordion [activeIndex]="0">
    @for (question of faq; track question) {
      <p-accordionTab [header]="question.question" >
        <p [innerHTML]="question.answer" ></p>
      </p-accordionTab>
    }
  </p-accordion>
</div>

